import React, { VoidFunctionComponent } from "react";
import { LongArrow } from "@/components/responsive/product/icons/LongArrow";

interface Props {
    isDisplayed: boolean;
    title?: string;
    children: JSX.Element;
    onClose: () => void;
    onBackHandler?: () => void;
    customHeader?: JSX.Element;
    classToApply?: string;
}

export const LayerLayout: VoidFunctionComponent<Props> = ({
    isDisplayed = true,
    title = "",
    children,
    onClose,
    onBackHandler,
    customHeader,
    classToApply = "",
}) => (
    <div
        className={isDisplayed ? `layer-content ${classToApply}` : 'none'}
        onClick={(e) => e.stopPropagation()}
    >
        <div className='layer-content-header'>
            <div className={`header-buttons ${title && title.length > 0 ? '' : 'large'}`}>
                {onBackHandler ? (
                    <div className='layer-back-button' onClick={() => onBackHandler()}>
                        <LongArrow />
                    </div>
                ) : (
                    <div />
                )}
                {title && title.length > 0 && <p className='layer-title'>{title}</p>}
                {customHeader}
                <div
                    className='layer-close-button'
                    onClick={() => {
                        onClose();
                    }}
                >
                    <img src={'/assets/images/responsive/svg/close.svg'} alt='icone pour fermer le menu' width="24" height="24" />
                </div>
            </div>
        </div>
        <div className='layer-content-body'>{children}</div>
    </div>
)